module.exports = __webpack_public_path__ + "static/media/pocketmags_button.2c1ad816.jpeg";